@if(item.navCap && !item.block){
<div mat-subheader class="nav-caption">
  {{ ('side_menu.' + item.navCap )| translate }}
</div>
} @if(!item.navCap && !item.external && !item.twoLines) {
@if(item.block && (!item.children || item.children.length === 0 || item.route)) {
<div class="menu-blocked-item" [style]="'--depth: ' + depth">
  <i-tabler [class]="'routeIcon ' + (item.iconClass || '')" name="{{ item.iconName }}"></i-tabler>
  <ng-container *ngIf="('side_menu.' + item.displayName) | translate as label">
    <span class="hide-menu" [matTooltip]="label" [matTooltipDisabled]="label.length <= sideNavLabelTruncateLength"
      matTooltipPosition="right">
      {{ label.length > sideNavLabelTruncateLength ? (label | slice:0:sideNavLabelTruncateLength) + '...' : label }}
    </span>
  </ng-container>
  <mat-icon class="lock-icon">lock</mat-icon>
</div>
} @else if(item.block && item.children && item.children.length) {
<a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
        'activeMenu': item.route
          ? router.isActive(item.route, true)
          : false,
        expanded: expanded
      }" [style]="'--depth: ' + depth" [attr.data-tour]="'nav-' + (item.displayName | lowercase)"
  class="menu-list-item blocked-parent">
  <i-tabler [class]="'routeIcon ' + (item.iconClass || '')" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <ng-container *ngIf="('side_menu.' + item.displayName) | translate as label">
    <span class="hide-menu" [matTooltip]="label" [matTooltipDisabled]="label.length <= sideNavLabelTruncateLength"
      matTooltipPosition="right">
      {{ label.length > sideNavLabelTruncateLength ? (label | slice:0:sideNavLabelTruncateLength) + '...' : label }}
    </span>
  </ng-container>
  <mat-icon class="lock-icon">lock</mat-icon>
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>
} @else {
<a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
        'activeMenu': item.route
          ? router.isActive(item.route, true)
          : false,
        expanded: expanded
      }" [style]="'--depth: ' + depth" [attr.data-tour]="'nav-' + (item.displayName | lowercase)"
  class="menu-list-item">
  <i-tabler [class]="'routeIcon ' + (item.iconClass || '')" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <ng-container *ngIf="('side_menu.' + item.displayName) | translate as label">
    <span class="hide-menu" [matTooltip]="label" [matTooltipDisabled]="label.length <= sideNavLabelTruncateLength"
      matTooltipPosition="right">
      {{ label.length > sideNavLabelTruncateLength ? (label | slice:0:sideNavLabelTruncateLength) + '...' : label }}
    </span>
  </ng-container>
  @if(item.children && item.children.length) {
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
  }
  @if(item.chip) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
  </span>
  }
</a>
}
}

<!-- external Link -->

@if(!item.navCap && item.external) {
<mat-list-item onClick="window.open('//google.com')" class="menu-list-item" target="_blank">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <ng-container *ngIf="('side_menu.' + item.displayName) | translate as label">
    <span class="hide-menu" [matTooltip]="label" [matTooltipDisabled]="label.length <= sideNavLabelTruncateLength"
      matTooltipPosition="right">
      {{ label.length > sideNavLabelTruncateLength ? (label | slice:0:sideNavLabelTruncateLength) + '...' : label }}
    </span>
  </ng-container>
</mat-list-item>
}

<!-- children -->
@if(expanded && item.children && item.children.length) { @for(child of item.children; track getNavItemTrackId(child)) {
<app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1">
</app-nav-item>
} }